import { useEffect, useRef, useState, useCallback } from 'react'

export const useIdle = (timeout: number = 3000) => {
  const [isIdle, setIsIdle] = useState(false)
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null)

  const resetTimer = useCallback(() => {
    setIsIdle(false)
    if (timerRef.current) {
      clearTimeout(timerRef.current)
    }
    timerRef.current = setTimeout(() => {
      setIsIdle(true)
    }, timeout)
  }, [timeout])

  useEffect(() => {
    if (typeof window === 'undefined') return

    const events = ['mousemove', 'mousedown', 'keydown', 'touchstart', 'scroll']

    resetTimer()

    events.forEach(event => {
      window.addEventListener(event, resetTimer, true)
    })

    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current)
      }
      events.forEach(event => {
        window.removeEventListener(event, resetTimer, true)
      })
    }
  }, [resetTimer])

  return isIdle
}